var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCt5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 67,
    height: 67,
    rx: 4,
    fill: "#EEE8FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_170_6995)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.112 43.833H18.888C18.3976 43.833 18 43.4354 18 42.945V27.1692C18 26.6788 18.3976 26.2812 18.888 26.2812H49.112C49.6024 26.2812 50 26.6788 50 27.1692V42.945C50 43.4354 49.6024 43.833 49.112 43.833Z",
    fill: "url(#paint0_linear_170_6995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4583 43.2253H19.5484C19.0858 43.2253 18.7109 42.8503 18.7109 42.3878V27.7281C18.7109 27.2655 19.0859 26.8906 19.5484 26.8906H48.4583C48.9208 26.8906 49.2958 27.2656 49.2958 27.7281V42.3878C49.2958 42.8503 48.9208 43.2253 48.4583 43.2253Z",
    fill: "url(#paint1_linear_170_6995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3163 31.6498C45.8341 31.6498 44.6325 30.4482 44.6325 28.9659C44.6325 28.9051 44.6346 28.8447 44.6386 28.7849C44.6581 28.4975 44.4313 28.2539 44.1433 28.2539H23.8571C23.5692 28.2539 23.3424 28.4976 23.3618 28.7849C23.3659 28.8447 23.3679 28.9051 23.3679 28.9659C23.3679 30.4482 22.1663 31.6498 20.6841 31.6498C20.6823 31.6498 20.6805 31.6498 20.6788 31.6498C20.4004 31.6492 20.1719 31.8683 20.1719 32.1467V37.969C20.1719 38.2474 20.4004 38.4665 20.6788 38.466H20.6841C22.1664 38.466 23.3679 39.6677 23.3679 41.1499C23.3679 41.2108 23.3659 41.2712 23.3618 41.331C23.3424 41.6183 23.5692 41.8619 23.8571 41.8619H44.1432C44.4311 41.8619 44.658 41.6183 44.6385 41.331C44.6344 41.2711 44.6324 41.2108 44.6324 41.1499C44.6324 39.6676 45.834 38.466 47.3162 38.466H47.3215C47.5999 38.4666 47.8284 38.2475 47.8284 37.969V32.1467C47.8284 31.8683 47.5999 31.6492 47.3215 31.6498C47.3198 31.6498 47.3181 31.6498 47.3163 31.6498Z",
    fill: "url(#paint2_linear_170_6995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9968 41.1713C37.3734 41.1713 40.1107 38.434 40.1107 35.0573C40.1107 31.6807 37.3734 28.9434 33.9968 28.9434C30.6201 28.9434 27.8828 31.6807 27.8828 35.0573C27.8828 38.434 30.6201 41.1713 33.9968 41.1713Z",
    fill: "url(#paint3_linear_170_6995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4 31.3662C36.307 31.2207 36.127 31.0997 35.859 31.0033C35.5702 30.8997 35.2624 30.8292 34.9363 30.7906C34.9188 30.7794 34.9011 30.7697 34.883 30.7614L34.4 30.2439C34.3242 30.1882 34.2424 30.1602 34.1548 30.1602C34.0591 30.1602 33.9773 30.1882 33.9096 30.2439C33.8418 30.2998 33.808 30.3635 33.808 30.4352V30.782C33.1622 30.8537 32.622 31.069 32.1875 31.4278C31.7528 31.7866 31.5357 32.3124 31.5357 33.005C31.5357 33.2516 31.5635 33.4764 31.6194 33.6793C31.675 33.8823 31.7668 34.0593 31.8944 34.2104C32.0219 34.3616 32.1435 34.4909 32.2592 34.5984C32.26 34.5991 32.2609 34.5999 32.2617 34.6006C32.2617 34.6006 33.7656 36.1046 33.7664 36.1052C33.7804 36.1202 33.794 36.1342 33.8078 36.1485V38.149C33.4545 38.1251 33.1434 38.0337 32.8743 37.8745C32.6052 37.7155 32.3939 37.5663 32.2398 37.4269C32.0859 37.2877 31.9616 37.218 31.8671 37.218C31.7243 37.218 31.5976 37.2936 31.4866 37.4449C31.3756 37.596 31.3203 37.7472 31.3203 37.8984C31.3203 38.1401 31.4565 38.3782 31.7288 38.613L36.9492 43.8334H48.8671L36.4 31.3662Z",
    fill: "url(#paint4_linear_170_6995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3203 37.8984C31.3203 37.7472 31.3756 37.5961 31.4866 37.4449C31.5976 37.2937 31.7243 37.218 31.8671 37.218C31.9616 37.218 32.0859 37.2877 32.2398 37.427C32.3938 37.5664 32.6052 37.7155 32.8743 37.8745C33.1434 38.0338 33.4545 38.1251 33.8078 38.149V35.3444C33.5687 35.2569 33.3851 35.1872 33.2577 35.1355C33.1301 35.0839 32.9606 35.0082 32.7495 34.9088C32.5381 34.8094 32.3746 34.7058 32.2591 34.5984C32.1434 34.4909 32.0218 34.3616 31.8944 34.2105C31.7667 34.0593 31.6749 33.8823 31.6193 33.6794C31.5635 33.4765 31.5356 33.2517 31.5356 33.005C31.5356 32.3125 31.7527 31.7866 32.1874 31.4279C32.6218 31.0691 33.1621 30.8538 33.8078 30.7821V30.4352C33.8078 30.3635 33.8417 30.2998 33.9095 30.2439C33.9771 30.1882 34.059 30.1602 34.1547 30.1602C34.2423 30.1602 34.324 30.1882 34.3998 30.2439C34.4755 30.2997 34.5135 30.3635 34.5135 30.4352V30.7581C34.9997 30.7742 35.4482 30.8558 35.8589 31.0033C36.2695 31.1509 36.4748 31.3561 36.4748 31.6192C36.4748 31.7627 36.4264 31.9122 36.33 32.0677C36.2336 32.2231 36.1048 32.3009 35.9441 32.3009C35.8806 32.3009 35.7059 32.2333 35.4204 32.0976C35.1347 31.9621 34.8323 31.8823 34.5135 31.8584V34.2821C34.8307 34.4015 35.0943 34.5148 35.3043 34.6223C35.5143 34.7298 35.7366 34.8789 35.9705 35.0699C36.2045 35.2608 36.3808 35.5015 36.4997 35.7919C36.6185 36.0823 36.6781 36.4225 36.6781 36.8124C36.6781 37.5247 36.4838 38.0909 36.0953 38.511C35.7066 38.931 35.1795 39.1891 34.5135 39.2852V39.6847C34.5135 39.7551 34.4755 39.8177 34.3998 39.8726C34.324 39.9274 34.2424 39.9548 34.1547 39.9548C34.059 39.9548 33.9771 39.9274 33.9095 39.8728C33.8417 39.8178 33.8078 39.7552 33.8078 39.6848V39.321C33.1143 39.313 32.5261 39.1543 32.0438 38.8449C31.5614 38.5354 31.3203 38.22 31.3203 37.8984ZM32.7196 32.8857C32.7196 33.1961 32.8162 33.4329 33.0096 33.5958C33.2028 33.759 33.4928 33.9122 33.8796 34.0553V31.8811C33.1062 31.9768 32.7196 32.3117 32.7196 32.8857ZM34.4417 38.1251C35.1432 37.9978 35.4941 37.6039 35.4941 36.9435C35.4941 36.5935 35.4023 36.319 35.219 36.1202C35.0355 35.9213 34.7766 35.7502 34.4417 35.6069V38.1251Z",
    fill: "url(#paint5_linear_170_6995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7082 35.7287H21.4957C21.3557 35.7287 21.2422 35.6152 21.2422 35.4751V34.6403C21.2422 34.5002 21.3557 34.3867 21.4957 34.3867H24.7082C24.8482 34.3867 24.9617 34.5002 24.9617 34.6403V35.4751C24.9617 35.6152 24.8482 35.7287 24.7082 35.7287Z",
    fill: "#4AB272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.534 35.7287H25.9801C25.8401 35.7287 25.7266 35.6152 25.7266 35.4751V34.6403C25.7266 34.5002 25.8401 34.3867 25.9801 34.3867H26.534C26.6741 34.3867 26.7876 34.5002 26.7876 34.6403V35.4751C26.7876 35.6152 26.6741 35.7287 26.534 35.7287Z",
    fill: "#4AB272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.472 35.7287H41.4645C41.3244 35.7287 41.2109 35.6152 41.2109 35.4751V34.6403C41.2109 34.5002 41.3244 34.3867 41.4645 34.3867H43.472C43.6121 34.3867 43.7256 34.5002 43.7256 34.6403V35.4751C43.7256 35.6152 43.6121 35.7287 43.472 35.7287Z",
    fill: "#4AB272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5036 35.7287H44.7223C44.5823 35.7287 44.4688 35.6152 44.4688 35.4751V34.6403C44.4688 34.5002 44.5823 34.3867 44.7223 34.3867H46.5036C46.6437 34.3867 46.7572 34.5002 46.7572 34.6403V35.4751C46.7572 35.6152 46.6436 35.7287 46.5036 35.7287Z",
    fill: "#4AB272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8615 26.2812H19.9012L19.6978 26.4847C19.2383 26.9442 19.4275 27.6727 19.9506 27.9122C20.0368 28.0958 21.0244 29.0906 21.2048 29.1806L21.2044 33.679C21.2044 33.7485 21.2156 33.8028 21.2361 33.845C21.2845 33.9443 28.2863 40.8352 31.3348 43.833H46.4132L28.8615 26.2812Z",
    fill: "url(#paint6_linear_170_6995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9983 27.1692C49.9983 26.6788 49.6008 26.2812 49.1103 26.2812H40.4392L40.4393 27.285C40.4394 27.7726 40.0441 28.1679 39.5565 28.1678C38.7699 28.1677 38.3761 29.1187 38.9323 29.675L39.1395 29.8822L49.9983 40.741V27.1692Z",
    fill: "url(#paint7_linear_170_6995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4394 27.2841L40.4389 22.4799C40.4389 22.1276 40.7245 22.1673 41.0767 22.1674L46.1527 22.1679C46.505 22.168 46.7905 22.1282 46.7905 22.4805L46.791 27.2848C46.791 27.7724 47.1863 28.1677 47.674 28.1678C48.4606 28.1678 48.8546 29.1189 48.2984 29.6751L44.2401 33.7335C43.8953 34.0782 43.3363 34.0782 42.9915 33.7333L38.9323 29.6742C38.3761 29.1179 38.7699 28.1669 39.5565 28.167C40.0441 28.167 40.4394 27.7717 40.4394 27.2841Z",
    fill: "url(#paint8_linear_170_6995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0734 22.8871L46.0738 27.2858C46.0739 28.1686 46.7922 28.8869 47.6751 28.887C47.7482 28.887 47.7994 28.9212 47.8273 28.9887C47.8553 29.0562 47.8433 29.1167 47.7916 29.1683L43.7332 33.2267C43.6933 33.2666 43.6478 33.275 43.6167 33.275C43.5856 33.275 43.5401 33.2666 43.5002 33.2267L39.441 29.1676C39.3893 29.1159 39.3773 29.0554 39.4053 28.988C39.4333 28.9205 39.4845 28.8863 39.5576 28.8863C40.4404 28.8863 41.1586 28.1682 41.1585 27.2854L41.1581 22.8867L46.0734 22.8871Z",
    fill: "url(#paint9_linear_170_6995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0766 22.1674C40.7243 22.1674 40.4388 22.1276 40.4389 22.4798L40.4393 27.2841C40.4394 27.7717 40.0441 28.167 39.5565 28.1669C38.7699 28.1669 38.3761 29.1178 38.9323 29.6741L42.9914 33.7333C43.1639 33.9057 43.3898 33.9919 43.6158 33.9919L43.6146 22.1676L41.0766 22.1674Z",
    fill: "url(#paint10_linear_170_6995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5565 28.8732L27.5561 33.6775C27.556 34.0298 27.2705 33.9901 26.9183 33.9901L21.8422 33.9906C21.49 33.9907 21.2044 34.0303 21.2045 33.6781L21.2049 28.8739C21.205 28.3863 20.8097 27.991 20.3221 27.9911C19.5355 27.9911 19.1417 27.0402 19.6979 26.4839L23.7569 22.4247C24.1018 22.0798 24.6608 22.0798 25.0055 22.4246L29.0639 26.4829C29.6201 27.0391 29.226 27.9901 28.4394 27.9902C27.9519 27.9903 27.5565 28.3857 27.5565 28.8732Z",
    fill: "url(#paint11_linear_170_6995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9237 33.2731L21.9241 28.8744C21.9242 27.9915 21.2061 27.2734 20.3232 27.2735C20.2501 27.2735 20.1989 27.2392 20.171 27.1718C20.143 27.1043 20.155 27.0439 20.2067 26.9922L24.2658 22.933C24.3057 22.8931 24.3512 22.8848 24.3823 22.8848C24.4134 22.8848 24.4589 22.8931 24.4988 22.933L28.5572 26.9914C28.6089 27.0431 28.6208 27.1035 28.5929 27.171C28.5649 27.2385 28.5137 27.2728 28.4406 27.2728C27.5578 27.2729 26.8395 27.9912 26.8394 28.874L26.8389 33.2727L21.9237 33.2731Z",
    fill: "url(#paint12_linear_170_6995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9209 33.992C27.2732 33.992 27.5587 34.0316 27.5587 33.6794L27.5592 28.8752C27.5592 28.3876 27.9545 27.9922 28.4422 27.9922C29.2287 27.9921 29.6228 27.041 29.0666 26.4848L25.0083 22.4265C24.8359 22.2541 24.6099 22.1679 24.3839 22.168L24.3828 33.9923L26.9209 33.992Z",
    fill: "url(#paint13_linear_170_6995)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_170_6995",
    x1: 32.3186,
    y1: 30.8032,
    x2: 41.2904,
    y2: 53.5012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4AB272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#077565"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_170_6995",
    x1: 35.3529,
    y1: 37.9609,
    x2: 18.0994,
    y2: 0.846638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92F37F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEE83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_170_6995",
    x1: 32.8921,
    y1: 31.6967,
    x2: 37.8894,
    y2: 46.8551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92F37F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AB272"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_170_6995",
    x1: 38.6867,
    y1: 38.1057,
    x2: 20.2877,
    y2: 26.1464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92F37F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AB272"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_170_6995",
    x1: 38.3114,
    y1: 38.1998,
    x2: 25.3776,
    y2: 32.4742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4AB272",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009245"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_170_6995",
    x1: 33.4182,
    y1: 34.5337,
    x2: 38.4281,
    y2: 37.9078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4AB272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#077565"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_170_6995",
    x1: 32.4453,
    y1: 36.4897,
    x2: 23.2845,
    y2: 20.8871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4AB272",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009245"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_170_6995",
    x1: 52.0453,
    y1: 35.8182,
    x2: 42.5029,
    y2: 26.2759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4AB272",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009245"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_170_6995",
    x1: 46.1373,
    y1: 28.9255,
    x2: 38.9232,
    y2: 23.7199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F92814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_170_6995",
    x1: 42.3711,
    y1: 26.9264,
    x2: 50.5763,
    y2: 30.7852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7044",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_170_6995",
    x1: 41.446,
    y1: 29.041,
    x2: 49.1009,
    y2: 17.6309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F92814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_170_6995",
    x1: 21.8589,
    y1: 27.2328,
    x2: 29.0717,
    y2: 32.4375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_170_6995",
    x1: 25.6264,
    y1: 29.2333,
    x2: 17.4227,
    y2: 25.3752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEE83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_170_6995",
    x1: 26.5527,
    y1: 27.1186,
    x2: 18.8968,
    y2: 38.5302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B53759"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_170_6995"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(18 17)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCt5);
export default __webpack_public_path__ + "static/media/ct5.ebe054f04b75894d97e3b1bcc53c2a24.svg";
export { ForwardRef as ReactComponent };